import { useMutation } from "@tanstack/react-query";
import { checkOrderStatus } from "../repositories/payment.repository";
import { API_ROUTES } from "../constants/apiRoutes";
import { useOrderStore } from "../store/useOrderStore";

export const useCheckOrderStatus = () => {
  const { mutate, error, isPending, isSuccess } = useMutation({
    mutationKey: [API_ROUTES.CHECK_PAYMENT_STATUS],
    mutationFn: async (orderId: string) => checkOrderStatus(orderId),
  });
  return {
    mutate,
    error,
    isPending,
    isSuccess,
  };
};
